<script setup>
import { watchEffect, ref } from "vue";
import { useRoute } from "vue-router";
import { fetchWithHeaders } from "@/utils";
import { toDateTime } from "@/filters";

const route = useRoute();
const mutations = ref([]);
const loading = ref(true);
const filter = ref("");
const initialPagination = {
    sortBy: "when",
    descending: true,
    page: 0,
    rowsPerPage: 50,
};
const columns = [
    { name: "when", label: "Quand", field: "when", align: "left", sortable: true, format: val => toDateTime(val) },
    { name: "who", label: "Qui", field: "who", align: "left", sortable: true },
    { name: "action", label: "Action", field: "action", align: "left", sortable: true },
    { name: "content", label: "Contenu", field: "content", align: "left", sortable: true },
];

watchEffect(async () => {
    const url = `${window._env_.API_ENDPOINT}/mutations/?session=${route.params.sessionCode}`;
    loading.value = true;
    mutations.value = await fetchWithHeaders(url);
    loading.value = false;
});
</script>
<template>
    <main>
        <q-card class="q-pa-md q-mt-lg q-mx-auto">
            <q-table
                title="Mutations"
                :rows="mutations"
                :columns="columns"
                :filter="filter"
                :loading="loading"
                :pagination="initialPagination"
                row-key="pk"
            >
                <template #top-right>
                    <q-input v-model="filter" borderless dense debounce="300" placeholder="Recherche">
                        <template #append>
                            <q-icon size="xs" name="fa-solid fa-search" />
                        </template>
                    </q-input>
                </template>
                <template #body-cell-who="props">
                    <q-td :props="props">
                        <div class="text-weight-bold">
                            {{ props.value }}
                        </div>
                    </q-td>
                </template>
                <template #body-cell-action="props">
                    <q-td :props="props">
                        <div>
                            <q-badge
                                :color="
                                    props.value == 'created'
                                        ? 'positive'
                                        : props.value == 'deleted'
                                        ? 'negative'
                                        : 'info'
                                "
                                :label="props.value"
                            />
                        </div>
                    </q-td>
                </template>
            </q-table>
            <div class="row q-mt-lg">
                <q-space />
                <q-btn color="primary" class="nav-button" label="Retour" :to="`/admin`" />
            </div>
        </q-card>
    </main>
</template>
